export default __webpack_public_path__ + "static/media/logo2.7cc5d0a8.png";